import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, IconButton } from '@mui/material';
import { Card } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { postTrackUserMerchantLogin } from 'src/apis/user.api';
import { outlines } from '../../Navigation/utils';
import { Image } from '../../components';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import Pill from '../Pill/Pill';
import styles from './styles';
export const MerchantCard = ({ data }) => {
    const { globalState, showSnackBar, updateGlobalState } = useGlobalStateContext();
    const { number, productOnboardingStatus, businessAddress } = data;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleCardClick = () => {
        // switch to different merchant
        const merchant = globalState.merchantList.find((o) => o.number == number);
        const selfServeMerchantNumbers = globalState?.selfServeMerchants?.reduce((acc, merchant) => {
            if (merchant.selfServeEligibility) {
                acc.push(merchant.merchantNumber);
            }
            return acc;
        }, []);
        if (number &&
            !selfServeMerchantNumbers?.includes(`${number}`) &&
            Boolean(!merchant?.productOnboardingStatus)) {
            // ineligible and not already onboarded
            return showSnackBar(t('MY_LOCATIONS_NOT_ALLOWED'), 'error');
            // TODO: add french translation for this snackbar message
        }
        updateGlobalState({
            merchant,
        });
        if (merchant?.productOnboardingStatus) {
            localStorage.setItem('idi-merchant-no', merchant?.number?.toString() || '');
            // Track user login
            postTrackUserMerchantLogin(Number(merchant.number));
            navigate('/sales');
        }
        else {
            localStorage.removeItem('idi-merchant-no');
            // remove from local storage to prevent ordering flow from locking to one store
            if (globalState.featureFlags.ordering)
                return navigate('/ordering');
            navigate('/onboarding');
        }
    };
    return (_jsx(Box, { sx: { flex: '0 0 28%', cursor: 'pointer', '&:focus': { outline: outlines.focus } }, onClick: handleCardClick, tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                handleCardClick();
            }
        }, children: _jsx(Card, { sx: styles.cardContainer, children: _jsxs(Box, { sx: styles.merchantCard, children: [_jsxs(Box, { sx: { display: 'flex', flexDirection: 'row' }, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h5', children: number }), _jsx(Typography, { variant: 'body1', mt: 1, color: 'secondary.light', children: t('MY_LOCATIONS_MERCHANTID') })] }), _jsx(Pill, { children: productOnboardingStatus
                                    ? t('MY_LOCATIONS_SUBSCRIBED')
                                    : t('MY_LOCATIONS_NOT_SUBSCRIBED'), backColor: productOnboardingStatus ? '#CCF8DE' : '#FFF2D1', borderStyle: productOnboardingStatus ? '2px solid #44A56B' : '2px solid #FFB600', chipVariant: 'outlined', sx: { marginLeft: 'auto', marginTop: '-5px' } })] }), _jsxs(Typography, { variant: 'body1', sx: styles.truncate2Lines, children: [businessAddress, " \u00A0"] }), _jsx(Box, { children: _jsxs(IconButton, { size: 'small', disableRipple: true, onClick: handleCardClick, sx: { padding: 0, height: '20px' }, children: [_jsx(Typography, { variant: 'body1', sx: styles.iconButton, children: t(productOnboardingStatus ? 'MY_LOCATIONS_CTA1' : 'MY_LOCATIONS_CTA2') }), _jsx(Image, { src: '/assets/images/forward-arrow.svg', alt: `${productOnboardingStatus
                                        ? 'redirects to Sales page'
                                        : 'redirects to Onboarding process'}` })] }) })] }) }) }));
};
export default MerchantCard;
